import { render, staticRenderFns } from "./index.vue?vue&type=template&id=59126a90&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=59126a90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59126a90",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SupportCategories: require('/opt/build/repo/storefront/components/legacy/support/support-categories.vue').default})
